var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.mostrarNoSerie,
          expression: "mostrarNoSerie"
        }
      ],
      attrs: { fluid: "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c("v-flex", [
            _c(
              "h2",
              {
                staticClass: "h2_title",
                staticStyle: { "margin-top": "12px !important" }
              },
              [_vm._v("\n        Equipos No Seriados\n      ")]
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-layout",
            { staticClass: "ml-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Buscar", outlined: "" },
                    on: {
                      keyup: function($event) {
                        return _vm.gridApi.setQuickFilter(_vm.filtro)
                      }
                    },
                    model: {
                      value: _vm.filtro,
                      callback: function($$v) {
                        _vm.filtro = $$v
                      },
                      expression: "filtro"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs2: "", sm2: "", md5: "" } }),
              _c("v-flex", { attrs: { xs3: "", sm3: "", md3: "" } })
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "DispositivosNoSeriados" },
            [
              _c("MantenedorGrid", {
                staticClass: "ag-theme-material",
                staticStyle: { "font-family": "'Asap', sans-serif" },
                attrs: { gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }